<template lang="pug">
  .calendar
    VueCal(
      hideViewSelector
      :events="eventList"
      :disableViews="getDisableViews()"
      locale="es"
      :timeFrom="8 * 60"
      :timeTo="21 * 60"
      todayButton
      :timeCellHeight="70"
      :activeView="getActiveView()"
      @ready="onChangeDate"
      @view-change="onChangeDate"
    )
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import VueCal from 'vue-cal'
import 'vue-cal/dist/i18n/es.js'
import 'vue-cal/dist/vuecal.css'

export default {
  components: {
    VueCal
  },
  data () {
    return {
      month: new Date().getMonth()
    }
  },
  methods: {
    ...mapActions(['listEvent']),
    inMobile () {
      return 700 > Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    },
    getDisableViews () {
      if (this.inMobile()) return ['years', 'year', 'month', 'week']
      return ['years', 'year', 'month', 'day']
    },
    getActiveView () {
      if (this.inMobile()) return 'day'
      return 'week'
    },
    onChangeDate(e) {
      if (this.month !== e.startDate.getMonth()) {
        this.month = e.startDate.getMonth()
        this.listEvent()
      }
    }
  },
  computed: {
    ...mapGetters(['events']),
    eventList () {
      const events = [...this.events]
      events.map(event => {
        event.start = this.$moment(event.start).format('YYYY-MM-DD HH:mm')
        event.end = this.$moment(event.end).format('YYYY-MM-DD HH:mm')
        event.class = 'vuecal-custom-event'
      })
      return events
    }
  },
  created () {
    this.listEvent()
  }
}
</script>

<style lang="scss">
@import '../../style/colors.scss';
.weekday-label {
  text-align: center;
  font: normal normal bold 14px/19px Open Sans;
  color:$text-dark  !important;
}
.vuecal-custom-event {
  background: #3498DB 0% 0% no-repeat padding-box;
  border-radius: 5px;
  text-align: center;
  font: normal normal normal 12px Open Sans;
  color: #FFFFFF;
  letter-spacing: 0px;
  padding: 2px;
}
.vuecal__title-bar {
  background: white;
  border-bottom: 1px solid #D1D1D1;
}
.vuecal__no-event {
  display: none;
}
</style>